import { render, staticRenderFns } from "./SourceObjectAttribute.vue?vue&type=template&id=f902f1b8&scoped=true&"
import script from "./SourceObjectAttribute.vue?vue&type=script&lang=ts&"
export * from "./SourceObjectAttribute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f902f1b8",
  null
  
)

export default component.exports